var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6.2C2.75 5.257 3.411 4.25 4.5 4.25H20.5C21.589 4.25 22.25 5.257 22.25 6.2V9.8C22.25 10.743 21.589 11.75 20.5 11.75H4.5C3.411 11.75 2.75 10.743 2.75 9.8V6.2ZM6.5 7.25C6.30109 7.25 6.11032 7.32902 5.96967 7.46967C5.82902 7.61032 5.75 7.80109 5.75 8C5.75 8.19891 5.82902 8.38968 5.96967 8.53033C6.11032 8.67098 6.30109 8.75 6.5 8.75H8.5C8.69891 8.75 8.88968 8.67098 9.03033 8.53033C9.17098 8.38968 9.25 8.19891 9.25 8C9.25 7.80109 9.17098 7.61032 9.03033 7.46967C8.88968 7.32902 8.69891 7.25 8.5 7.25H6.5ZM2.75 15.2C2.75 14.257 3.411 13.25 4.5 13.25H20.5C21.589 13.25 22.25 14.257 22.25 15.2V18.8C22.25 19.743 21.589 20.75 20.5 20.75H4.5C3.411 20.75 2.75 19.743 2.75 18.8V15.2ZM6.5 16.25C6.30109 16.25 6.11032 16.329 5.96967 16.4697C5.82902 16.6103 5.75 16.8011 5.75 17C5.75 17.1989 5.82902 17.3897 5.96967 17.5303C6.11032 17.671 6.30109 17.75 6.5 17.75H8.5C8.69891 17.75 8.88968 17.671 9.03033 17.5303C9.17098 17.3897 9.25 17.1989 9.25 17C9.25 16.8011 9.17098 16.6103 9.03033 16.4697C8.88968 16.329 8.69891 16.25 8.5 16.25H6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServers);
export default __webpack_public_path__ + "static/media/servers.03cc32597a74eba70d47d09c7a3ea41d.svg";
export { ForwardRef as ReactComponent };